module.exports = __webpack_public_path__ + "img/tuozhan02.d68c84fa.png";